import { Component, OnInit } from '@angular/core';
import { MediaService } from '../../services/media.service';

@Component({
  selector: 'app-mediatheque',
  templateUrl: './mediatheque.component.html',
  styleUrls: ['./mediatheque.component.css']
})
export class MediathequeComponent implements OnInit {

  images: { nom: string; url: string; taille: number; date: string }[] = [];
  recherche = '';
  messageConfirmation = '';
  urlCopiee = '';
  chargementEnCours = true;
  importEnCours = false;

  constructor(private mediaService: MediaService) { }

  ngOnInit(): void {
    this.charger();
  }

  charger(): void {
    this.chargementEnCours = true;
    this.mediaService.liste().subscribe({
      next: (data) => {
        this.images = data;
        this.chargementEnCours = false;
      },
      error: () => {
        this.chargementEnCours = false;
      }
    });
  }

  get imagesFiltrees(): { nom: string; url: string; taille: number; date: string }[] {
    if (!this.recherche.trim()) return this.images;
    const q = this.recherche.trim().toLowerCase();
    return this.images.filter(img => img.nom.toLowerCase().includes(q));
  }

  onFichierSelectionne(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const fichier = input.files[0];
    this.importEnCours = true;

    this.mediaService.uploadImage(fichier).subscribe({
      next: (reponse) => {
        this.importEnCours = false;
        if (reponse.success) {
          this.messageConfirmation = 'Image importée avec succès !';
          setTimeout(() => this.messageConfirmation = '', 3000);
          this.charger();
        }
      },
      error: () => {
        this.importEnCours = false;
        alert("Erreur lors de l'import de l'image.");
      }
    });

    input.value = '';
  }

  supprimer(img: { nom: string; url: string }): void {
    if (!confirm(`Supprimer définitivement "${img.nom}" ? Elle disparaîtra de tous les endroits où elle est utilisée.`)) return;
    this.mediaService.supprimer(img.nom).subscribe(() => {
      this.images = this.images.filter(i => i.nom !== img.nom);
    });
  }

  copierUrl(url: string): void {
    navigator.clipboard.writeText(url).then(() => {
      this.urlCopiee = url;
      setTimeout(() => this.urlCopiee = '', 2000);
    });
  }

  formatTaille(octets: number): string {
    if (octets < 1024) return `${octets} o`;
    if (octets < 1024 * 1024) return `${Math.round(octets / 1024)} Ko`;
    return `${(octets / (1024 * 1024)).toFixed(1)} Mo`;
  }
}
